export interface PageRequest {
    page: number;
    page_size: number;
}
